module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('va-small-box', {
    staticClass: "info-box box-blue",
    attrs: {
      "icon": "ion-briefcase ",
      "title": _vm.totalCollectionAmt,
      "description": "Total Collection Amount",
      "moreText": "More info"
    },
    on: {
      "more-click": _vm.clickToSmallBox
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f041cb8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/totalcollection.vue
// module id = 781
// module chunks = 0